import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

const AccountPage = () => {
  const [showPassword, setShowPassword] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);
  const navigate = useNavigate();

  const handleRegister = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess(false);

    if (password !== confirmPassword) {
      setError("Passwords do not match");
      return;
    }

    try {
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/api/auth/register`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ email, password }),
        }
      );

      const data = await response.json();

      if (response.ok) {
        setSuccess(true);
      } else {
        setError(data.message || "Registration failed");
      }
    } catch (err) {
      setError("An error occurred. Please try again.");
      console.error(err);
    }
  };

  return (
    <div className="welcome_page">
      <div className="sidebar">
        <img
          src="sidebar_avatar.png"
          alt="Sidebar Avatar"
          className="sidebar_avatar"
        />
        <img
          src="church_logo_no_bg.png"
          alt="Church Logo"
          className="church_logo"
        />
      </div>

      <div className="form_side">
        <button
          onClick={() => navigate("/")}
          className="mb-4 text-blue-600 hover:underline"
        >
          ← Return to Login
        </button>
        <div className="form_main">
          <div className="form_head">
            <h1>Create Account</h1>
            <p>Register as a Lecturer</p>
          </div>

          <div className="form_body">
            <form onSubmit={handleRegister}>
              <div className="form_body1">
                <label htmlFor="email">EMAIL ADDRESS</label>
                <input
                  type="email"
                  placeholder="johndoe@example.com"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </div>

              <div className="form_body1 form_pass">
                <label htmlFor="password">PASSWORD</label>
                <input
                  type={showPassword ? "text" : "password"}
                  placeholder="************"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
              </div>

              <div className="form_body1 form_pass">
                <label htmlFor="confirmPassword">CONFIRM PASSWORD</label>
                <input
                  type={showPassword ? "text" : "password"}
                  placeholder="************"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  required
                />
                <button
                  type="button"
                  className="form_toggle_btn"
                  onClick={() => setShowPassword(!showPassword)}
                >
                  {showPassword ? "🙈" : "👁️"}
                </button>
              </div>

              {error && (
                <p style={{ color: "red", fontSize: "small" }}>{error}</p>
              )}

              {success && (
                <p style={{ color: "green", fontSize: "small" }}>
                  ✅ Account created!{" "}
                  <span
                    style={{ textDecoration: "underline", cursor: "pointer" }}
                    onClick={() => navigate("/")}
                  >
                    Click here to login
                  </span>
                </p>
              )}

              <button className="form_login_btn" type="submit">
                CREATE ACCOUNT
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AccountPage;
